import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {

    // 区域类型下拉
    findAreaTypeChioce({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get(`/deptArea/findAreaTypeChioce`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
    // 速查表列表
    findAll({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`deptArea/findList`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
    // 根据ID删除数据
    delById({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`deptArea/deleteById`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
    // 根据ID查询信息详情
    findById({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`deptArea/findById`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
    //  保存数据
    save({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`deptArea/save`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
};
